// components/BlogCard.jsx
import React, { useEffect } from 'react';
import classes from './styles/blogCard.module.css';
import { getImageUrlWithSas } from '../../services/SAS';

const BlogCard = ({ blog }) => {
  const [imgUrl, setImgUrl] = React.useState('');
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const getExcerpt = (content, excerpt, maxLength = 100) => {
    if (excerpt && excerpt !== 'string') return excerpt;
    const text = stripHtml(content);
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  useEffect(() => {
    const fetchImageUrl = async () => {
        try {
            const response = await getImageUrlWithSas(blog.featured_image_url);
            setImgUrl(response.data.url); 
        } catch (error) {
            console.error("Error fetching image URL:", error);
            setImgUrl('https://www.fetchjobs.co/static/media/fetchjobLogo.aa2faf0113cf3ef779e0.png');
        }
    };

    fetchImageUrl();
  }, [blog.featured_image_url]);

  return (
    <div className={classes.blogCard}>
      <div className={classes.blogCardImage}>
        <a href={`/blog/${blog.slug}`}>
          {blog.featured_image_url && blog.featured_image_url !== 'string' ? (
            <img 
              src={imgUrl} 
              alt={blog.title}
            />
          ) : (
            <div className={classes.noImage}>No Image</div>
          )}
        </a>
      </div>
      <div className={classes.blogCardContent}>
        <div className={classes.blogCategory}>
          {blog.category && blog.category !== 'string' ? blog.category : 'Article'}
        </div>
        <h3 className={classes.blogTitle}>
          <a href={`/blog/${blog.slug}`}>{blog.title}</a>
        </h3>
        <div className={classes.blogMeta}>
          <span className={classes.blogAuthor}>By {blog.author && blog.author !== 'string' ? blog.author : 'Admin'}</span>
          <span className={classes.blogDate}>{formatDate(blog.createdAt)}</span>
        </div>
        <p className={classes.blogExcerpt}>
          {getExcerpt(blog.content, blog.excerpt)}
        </p>
        {blog.tags && blog.tags.length > 0 && blog.tags[0] !== 'string' && (
          <div className={classes.blogTags}>
            {blog.tags.slice(0, 3).map((tag, index) => (
              <span key={index} className={classes.blogTag}>#{tag}</span>
            ))}
          </div>
        )}
        <a href={`/blog/${blog.slug}`} className={classes.readMore}>
          Read More →
        </a>
      </div>
    </div>
  );
};

export default BlogCard;